import MenuContentList from './MenuContentList'

export default MenuContentList
